module.exports = __webpack_public_path__ + "static/media/bg.870f1013.png";